import { prefetchUsersGridView } from "../../../api/users";
import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import { userGridPageRoutes } from "./UserGridPage";

export const route: NavigationItemType["route"] = { path: "settings/people", children: userGridPageRoutes };
export const to = (paths: Paths) => paths.usersGrid();

export const prefetch = prefetchUsersGridView;
